export default "Sarah: omg I just got engaged 💍🥹\n"